export const SET_SCANNED_CODE = 'SET_SCANNED_CODE';
